// user
export const AUTH = {
  CHECK: "checkAuth",
  LOGIN: "login",
  LOGOUT: "logout",
  REGISTER: "register",
  UPDATE: "updateAuth",
  UPLOAD: "upload",
  SET: "setAuth",
  DEL: "deleteAuth",
};
// Auth
export const USER = {
  AUTH: "authUser",
  FETCH: "fetchUsers",
  GET: "getUser",
  GETBASIC: "getUserBasicInfo",
  ISVALID_USERNAME: "checkValidUsername",
  REGISTER: "registerUser",
  CREATE: "createUser",
  UPDATE: "updateUser",
  DEL: "deleteUser",
  SET: "setUser",
  SETAUTH: "setUserAuth",
  UPLOAD_AVATAR: 'uploadAvatar',
  LOGOUT: "logoutUser",
  LOGIN: "loginUser"
};
// Trader
export const TRADER = {
  FETCH: "fetchTraders",
  GET: "getTrader",
  EDIT: "editTrader",
  DEL: "deleteTrader",
  SET: "setTrader"
};
// Acc
export const ACCOUNT = {
  FETCH: "fetchAccounts",
  GET: "getAccount",
  CREATE: "createAccount",
  EDIT: "editAccount",
  DEL: "deleteAccount",
  SET: "setAccount",
};
// Strategy
export const STRATEGY = {
  FETCH: "fetchStrategies",
  GET: "getStrategy",
  CREATE: "createStrategy",
  EDIT: "editStrategy",
  DEL: "deleteStrategy",
  SET: "setStrategy"
};
// Command
export const COMMAND = {
  FETCH: "fetchCommands",
  GET: "getCommand",
  CREATE: "createCommand",
  EDIT: "editCommand",
  DEL: "deleteCommand",
  SET: "setCommand"
};
// Subscription
export const SUBSCRIPTION = {
  GET_TRADER: "getSubscriptionsAsTrader",
  SET_TRADER: "setSubscriptionsAsTrader",
  GET_INVESTOR: "getSubscriptionsAsInvestor",
  SET_INVESTOR: "setSubscriptionsAsInvestor",
  FETCH: "fetchSubscriptions",
  PETCH_ACC: "fetchAccSubscriptions",
  GET: "getSubscription",
  CREATE: "createSubscription",
  EDIT: "editSubscription",
  DEL: "deleteSubscription",
  SET: "setSubscription",
  SET_LAST: "setLastSubscription",
  SUBSCRIBE_TOPIC: "subscribeTopic"

};
// Terminal
export const TERMINAL = {
  FETCH: "fetchStrategies",
  GET: "getTerminal",
  CREATE: "createTerminal",
  EDIT: "editTerminal",
  DEL: "deleteTerminal",
  SET: "setTerminal",
  TELEGRAM_DECODE: "telegramDecode"
};
// Command
export const PLAN = {
  FETCH: "fetchPlans",
  GET: "getPlan",
  CREATE: "createPlan",
  EDIT: "editPlan",
  DEL: "deletePlan",
  SET: "setPlan"
};
// Sale
export const SALE = {
  FETCH: "fetchSales",
  GET: "getSale",
  CREATE: "createSale",
  EDIT: "editSale",
  DEL: "deleteSale",
  SET: "setSale"
};
// Error
export const ERROR = {
  PUSH: "pushError",
  SET: "setError",
  DEL: "delError"
};
// Loading
export const LOADING = {
  TOGGLE: "toggleLoading",
  SET: "setLoading"
};
// Schema
export const SCHEMA = {
  GET: "getSchema",
};
// Menu
export const MENU = {
  FETCH: "fetchMenu",
  SET: "setMenu",
  GET: "getMenu",
};